<!-- Mode Tabs -->
<div class="ticket-dialog-tabs">
  <button class="tab-btn" [class.active]="activeMode() === 'scan'" (click)="setMode('scan')">
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
      <rect x="14" y="3" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
      <rect x="3" y="14" width="7" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
      <path d="M14 14h3v3h-3v3h3m3-6v6h-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    {{ 'ADD_TICKET.SCAN_QR' | translate }}
  </button>
  <button class="tab-btn" [class.active]="activeMode() === 'manual'" (click)="setMode('manual')">
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="m18.5 2.5 3 3L12 15H9v-3l9.5-9.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    {{ 'ADD_TICKET.ENTER_MANUALLY' | translate }}
  </button>
</div>

<!-- ── Scan QR Mode ─────────────────────────────────── -->
@if (activeMode() === 'scan') {
  @if (isMobile) {
    <div class="scanner-wrapper">
      <!-- Camera container filled by Html5Qrcode -->
      <div id="qr-scanner-container" class="qr-scanner-container"></div>

      @if (!scannerActive() && !scannerError()) {
        <div class="scanner-skeleton">
          <p-skeleton height="260px" borderRadius="16px" />
        </div>
      }

      @if (scannerError()) {
        <div class="scanner-error-msg">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#c0392b" stroke-width="1.5"/>
            <path d="M12 8v4m0 4h.01" stroke="#c0392b" stroke-width="2" stroke-linecap="round"/>
          </svg>
          <span>{{ scannerError()! | translate }}</span>
        </div>
        <div class="mt-3 text-center">
          <app-button
            [label]="'ADD_TICKET.TRY_MANUALLY' | translate"
            [color]="'outline-primary'"
            (click)="setMode('manual')">
          </app-button>
        </div>
      }

      @if (scannerActive()) {
        <p class="scanner-hint">{{ 'ADD_TICKET.SCANNER_HINT' | translate }}</p>
      }
    </div>
  } @else {
    <app-placeholder
      [title]="'ADD_TICKET.SCANNER_NOT_AVAILABLE_TITLE'"
      [subTitle]="'ADD_TICKET.SCANNER_NOT_AVAILABLE_DESC'"
      [icon]="'assets/images/mobile-scanning.svg'"
      [showButton]="'true'"
      [buttonLabel]="'ADD_TICKET.ENTER_MANUALLY'"
      (action)="setMode('manual')">
    </app-placeholder>
  }
}

<!-- ── Manual Entry Mode ──────────────────────────────── -->
@if (activeMode() === 'manual') {
  <div class="manual-entry-form">
    <div class="form-group">
      <label class="form-label">{{ 'ADD_TICKET.TICKET_NUMBER_LABEL' | translate }}</label>
      <input
        pInputText
        [(ngModel)]="ticketNumber"
        (ngModelChange)="onTicketNumberChange($event)"
        [placeholder]="'ADD_TICKET.TICKET_NUMBER_PLACEHOLDER' | translate"
        class="w-100" />
      @if (ticketNumber.trim() && !isTicketNumberValidFormat()) {
        <small class="field-error">{{ 'ADD_TICKET.VALIDATION_PT_PREFIX' | translate }}</small>
      }
    </div>

    @if (lookupErrorKey()) {
      <div class="lookup-error mt-3">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="12" cy="12" r="10" stroke="#c0392b" stroke-width="1.5"/>
          <path d="M12 8v4m0 4h.01" stroke="#c0392b" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span>{{ lookupErrorKey()! | translate }}</span>
      </div>
    }

    <app-button
      [label]="isLoading() ? ('GENERAL.LOADING' | translate) : ('ADD_TICKET.ADD_TICKET_BTN' | translate)"
      [color]="'primary'"
      [disabled]="isLoading() || !isTicketNumberValidFormat()"
      class="w-100 d-block mt-3"
      [class.btn-disabled]="isLoading() || !isTicketNumberValidFormat()"
      (click)="isLoading() || !isTicketNumberValidFormat() ? null : lookupTicket()">
    </app-button>

    <!-- Loading skeleton -->
    <!-- @if (isLoading()) {
      <div class="result-skeleton mt-4">
        <p-skeleton height="160px" borderRadius="16px" />
      </div>
    } -->

    <!-- Ticket found result -->
    @if (!isLoading() && foundTicket()) {
      <div class="ticket-result mt-4">
        <p class="result-label">{{ 'ADD_TICKET.TICKET_FOUND_TITLE' | translate }}</p>

        <div class="ticket-card">
          <div class="ticket-card-title-band">
            <span class="ticket-no">{{ 'HOME.TICKET_NO_PREFIX' | translate }}{{ foundTicket().ticketNo }}</span>
          </div>

          <div class="ticket-time-row">
            <div class="ticket-time-block">
              <span class="ticket-time">{{ foundTicket().startTime }}</span>
              <span class="ticket-date">{{ foundTicket().date }}</span>
            </div>
            <div class="ticket-duration-connector">
              <span class="connector-dot"></span>
              <span class="connector-line"></span>
              <span class="connector-label">{{ foundTicket().duration }}</span>
              <span class="connector-line"></span>
              <span class="connector-dot"></span>
            </div>
            <div class="ticket-time-block ticket-time-block--end">
              <span class="ticket-time">{{ foundTicket().endTime }}</span>
              <span class="ticket-date">{{ foundTicket().date }}</span>
            </div>
          </div>

          <div class="ticket-perforated-divider">
            <span class="cutout cutout--left"></span>
            <span class="dashed-line"></span>
            <span class="cutout cutout--right"></span>
          </div>

          <div class="ticket-card-body">
            <div class="ticket-location">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 13.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
                  stroke="#636363" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 21C12 21 4 15.5 4 9.5a8 8 0 1 1 16 0C20 15.5 12 21 12 21Z"
                  stroke="#636363" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{ foundTicket().location }}</span>
            </div>
            <div class="ticket-footer">
              <div class="ticket-amount">
                <app-riyal-symbol class="ticket-riyal-symbol"></app-riyal-symbol>
                <span>{{ foundTicket().amount | number:'1.2-2' }}</span>
              </div>
              <span class="ticket-status-pill"
                [ngClass]="foundTicket().status === 'Settled' ? 'settled' : 'unpaid'">
                @if (foundTicket().status === 'Settled') {
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 6L9 17l-5-5" stroke="#1d7a40" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                }
                {{ foundTicket().status === 'Settled'
                    ? ('HOME.TICKET_STATUS_SETTLED' | translate)
                    : ('HOME.TICKET_STATUS_UNPAID' | translate) }}
              </span>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
